import React, {Component} from 'react';
import {connect} from 'react-redux';
import {toastr} from 'react-redux-toastr';
import {withStyles} from 'material-ui/styles';
import styles from '../style/styles';
import BlockTranslationNewForm from '../forms/CreateTranslationForm';
import {updateBlockTranslation} from '../thunks';
import {onPickBlockPage, togglePagePickerPopup} from '../actions';
import {onSearchPages} from '../../page-picker/thunks';

class BlockTranslationCreate extends Component {
    shouldComponentUpdate(nextProps, nextState) {
        return nextProps.loading !== true;
    }

    handleCreateBlockTranslationSubmit(formProps) {
        this.props.updateBlockTranslation(formProps);
    }

    componentWillUnmount() {
        toastr.removeByType('error');
    }

    render() {
        const {pagePicker} = this.props;

        return (
            this.props.loading !== true && (
                <BlockTranslationNewForm
                    blockSiteTranslation={this.props.blockSiteTranslation}
                    block={this.props.block}
                    initialValues={this.props.initialValues}
                    handleFormSubmit={this.handleCreateBlockTranslationSubmit.bind(
                        this
                    )}
                    classes={this.props.classes}
                    touched={this.props.touched}
                    loading={this.props.loading}
                    siteId={this.props.siteId}
                    pageSearchCriteria={this.props.pageSearchCriteria}
                    togglePagePickerPopup={this.props.togglePagePickerPopup}
                    onSearchPages={this.props.onSearchPages}
                    pagePickerPopupOpen={pagePicker.popupOpen}
                    pagePickerPage={pagePicker.page}
                    allPagesBySearchCriteria={
                        this.props.allPagesBySearchCriteria
                    }
                    onPickBlockPage={this.props.onPickBlockPage}
                />
            )
        );
    }
}

const mapStateToProps = (state, props) => ({
    initialValues: {
        block_type_id: state.blocks.blockSiteTranslation.block_type_id,
        block_id: state.blocks.blockSiteTranslation.block_id,
        id: state.blocks.blockSiteTranslation.id,
        display_name: state.blocks.blockSiteTranslation.display_name,
        title: state.blocks.blockSiteTranslation.title,
        body: state.blocks.blockSiteTranslation.body,
        button_text: state.blocks.blockSiteTranslation.button_text,
        pagePicker: state.blocks.pagePicker,
    },
    blockSiteTranslation: state.blocks.blockSiteTranslation,
    loading: state.layout.ajaxCallsInProgress > 0,
    touched: state.blocks.touched,
    allPagesBySearchCriteria: state.pagePicker.allPagesBySearchCriteria,
    pageSearchCriteria: state.pagePicker.pageSearchCriteria,
    pagePicker: state.blocks.pagePicker,
});

export default connect(mapStateToProps, {
    updateBlockTranslation,
    onPickBlockPage,
    togglePagePickerPopup,
    onSearchPages,
})(withStyles(styles)(BlockTranslationCreate));



// WEBPACK FOOTER //
// ./src/containers/blocks/translations/BlockTranslationCreate.jsx